// extracted by mini-css-extract-plugin
export var fs11_fw600 = "typography-module--fs11_fw600--fce4e";
export var style_container = "JobTag-module--style_container--87fc3 typography-module--typeface_base--8d193";
export var style_value = "JobTag-module--style_value--084f8 typography-module--fs11_fw600--fce4e";
export var typeface_base = "typography-module--typeface_base--8d193";
export var typography = "\"@theme/typography.module.css\"";